"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterButton = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _baseReactComponents = require("@navinc/base-react-components");

var _filterState = require("../util/filter-state");

var _testId = require("../util/test-id");

var _jsxRuntime = require("react/jsx-runtime");

var NativeSelect = (0, _styledComponents["default"])(_baseReactComponents.Select).withConfig({
  displayName: "NativeSelect",
  componentId: "sc-1p5czdb-0"
})(["opacity:0;"]);
var CenteredCopy = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "CenteredCopy",
  componentId: "sc-1p5czdb-1"
})(["text-align:center;"]);

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-1p5czdb-2"
})(["display:flex;position:relative;flex-direction:column;align-items:center;justify-content:flex-start;overflow:visible;max-width:100%;max-height:100%;& > ", "{position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;}"], NativeSelect);

var Button = _styledComponents["default"].button.withConfig({
  displayName: "Button",
  componentId: "sc-1p5czdb-3"
})(["display:block;position:relative;padding:24px;border:2px solid transparent;border-radius:20px;margin-bottom:16px;box-shadow:0 16px 24px -16px rgba(0,0,0,0.25);background-color:", ";", ":hover &,", ":focus &{border:2px solid ", ";}"], function (_ref) {
  var theme = _ref.theme,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active;
  return active ? theme.bubbleBlue200 : theme.belugaWhite;
}, Wrapper, Wrapper, function (_ref2) {
  var theme = _ref2.theme;
  return theme.bubbleBlue400;
});

var Icon = _styledComponents["default"].div.withConfig({
  displayName: "Icon",
  componentId: "sc-1p5czdb-4"
})(["display:block;height:32px;width:32px;mask-image:url('", "');-webkit-mask-image:url('", "');background:", ";", ":hover &,", ":focus &{background:", ";}"], function (_ref3) {
  var icon = _ref3.icon;
  return icon;
}, function (_ref4) {
  var icon = _ref4.icon;
  return icon;
}, function (_ref5) {
  var _ref5$active = _ref5.active,
      active = _ref5$active === void 0 ? false : _ref5$active,
      theme = _ref5.theme;
  return active ? theme.bubbleBlue400 : theme.neutral500;
}, Wrapper, Wrapper, function (_ref6) {
  var theme = _ref6.theme;
  return theme.bubbleBlue400;
});

var AccessibilityText = _styledComponents["default"].div.withConfig({
  displayName: "AccessibilityText",
  componentId: "sc-1p5czdb-5"
})(["color:", ";text-indent:-1000em;position:absolute;"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.belugaWhite;
});

var FilterButton = (0, _styledComponents["default"])(function (_ref8) {
  var _activeFilters$name, _, _activeFilters$name2;

  var className = _ref8.className,
      icon = _ref8.icon,
      children = _ref8.children,
      name = _ref8.name,
      _ref8$options = _ref8.options,
      options = _ref8$options === void 0 ? [] : _ref8$options,
      _ref8$activeFilters = _ref8.activeFilters,
      activeFilters = _ref8$activeFilters === void 0 ? {} : _ref8$activeFilters,
      _ref8$enableMultipleC = _ref8.enableMultipleChoiceFilters,
      enableMultipleChoiceFilters = _ref8$enableMultipleC === void 0 ? false : _ref8$enableMultipleC,
      _ref8$onChange = _ref8.onChange,
      _onChange3 = _ref8$onChange === void 0 ? function () {} : _ref8$onChange,
      _ref8$onClick = _ref8.onClick,
      onClick = _ref8$onClick === void 0 ? function () {} : _ref8$onClick;

  var testIdName = (0, _testId.formatForTestId)(name);
  var isSingleOption = (0, _filterState.isFilterSingleOption)(name, options);
  var hasDropdown = enableMultipleChoiceFilters && !isSingleOption;
  var isActive = (0, _filterState.isFilterInUse)(activeFilters, name);

  var handleClick = function handleClick() {
    onClick();

    if (!hasDropdown) {
      if (isActive) {
        _onChange3({});
      } else {
        _onChange3((0, _defineProperty2["default"])({}, name, options));
      }
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Wrapper, {
    className: className,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(Button, {
      active: isActive,
      "data-testid": "icon-filter:filter-".concat(testIdName, ":button"),
      onClick: handleClick,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
        icon: icon,
        active: isActive
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(AccessibilityText, {
        children: name
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CenteredCopy, {
      light: true,
      bold: isActive,
      onClick: handleClick,
      children: children
    }), !isSingleOption && enableMultipleChoiceFilters && /*#__PURE__*/(0, _jsxRuntime.jsx)(NativeSelect, {
      options: options,
      value: enableMultipleChoiceFilters ? (_activeFilters$name = activeFilters[name]) !== null && _activeFilters$name !== void 0 ? _activeFilters$name : [] : (_ = ((_activeFilters$name2 = activeFilters[name]) !== null && _activeFilters$name2 !== void 0 ? _activeFilters$name2 : [])[0]) !== null && _ !== void 0 ? _ : '',
      onChange: function onChange(e) {
        return _onChange3((0, _defineProperty2["default"])({}, name, e.target.value));
      },
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      "data-testid": "icon-filter:filter-".concat(testIdName, ":select")
    })]
  });
}).withConfig({
  displayName: "FilterButton",
  componentId: "sc-1p5czdb-6"
})([""]);
exports.FilterButton = FilterButton;
FilterButton.displayName = 'FilterButton';
//# sourceMappingURL=filter-button.js.map